import axios from 'axios'

const apiClient = axios.create({
  baseURL: 'https://collis.pythonanywhere.com/api',
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  }
})

// Request interceptor to add token
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token')
    console.log('API Client: Request to', config.url)
    console.log('API Client: Token in storage:', !!token)
    if (token) {
      config.headers.Authorization = `Token ${token}`
      console.log('API Client: Authorization header set')
    } else {
      console.warn('API Client: No token found in localStorage')
    }
    return config
  },
  (error) => Promise.reject(error)
)

// Response interceptor for error handling
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Clear auth and redirect to login
      localStorage.removeItem('token')
      localStorage.removeItem('user')
      window.location.href = '/login'
    }
    return Promise.reject(error)
  }
)

export default apiClient